import ContentPageLayout from 'components/ContentPageLayout'

const AboutUs = (): JSX.Element => {
	return <ContentPageLayout contentKey="aboutus" />
}

export default AboutUs
